import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["height"]


export default /*#__PURE__*/_defineComponent({
  __name: 'IconClose',
  props: {
    className: {},
    classStroke: {},
    size: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: _normalizeClass(_ctx.className),
    height: _ctx.size || 18,
    viewBox: "0 0 13.414 13.414"
  }, [
    _createElementVNode("line", {
      id: "Line_539",
      class: _normalizeClass(`${_ctx.classStroke} svg-stroke`),
      "data-name": "Line 539",
      x2: "12",
      y2: "12",
      transform: "translate(0.707 0.707)",
      fill: "none",
      stroke: "#888f94",
      "stroke-linejoin": "round",
      "stroke-width": "3"
    }, null, 2),
    _createElementVNode("line", {
      id: "Line_540",
      class: _normalizeClass(`${_ctx.classStroke} svg-stroke`),
      "data-name": "Line 540",
      y1: "12",
      x2: "12",
      transform: "translate(0.707 0.707)",
      fill: "none",
      stroke: "#888f94",
      "stroke-linejoin": "round",
      "stroke-width": "3"
    }, null, 2)
  ], 10, _hoisted_1))
}
}

})